import controller from './carousel-category.controller';
import templateBase from './views/carousel-category-base.view.html';

let CarouselCategoryComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        itemName: '@',
        type: '@',
    }
};


function changeTemplate() {
    return templateBase;
}

export default CarouselCategoryComponent;



/** WEBPACK FOOTER **
 ** ./www/components/home/carousel-category/carousel-category.component.js
 **/